import { useCallback, useEffect, useState } from "react";

const getMobileDetect = (userAgent) => {
  const isAndroid = () => Boolean(userAgent.match(/Android/i));
  const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isOpera = () => Boolean(userAgent.match(/Opera Mini/i));
  const isWindows = () => Boolean(userAgent.match(/IEMobile/i));

  const isUnder720 = () => window.innerWidth < 720;

  const isMobile = () =>
    Boolean(isAndroid() || isIos() || isOpera() || isWindows() || isUnder720());
  const isDesktop = () => !isMobile();

  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
    isUnder720,
  };
};

const useMobileDetect = () => {
  const [, setReload] = useState(Date.now());

  const onResize = useCallback(() => setReload(Date.now()), []);

  useEffect(() => {
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, [onResize]);

  return getMobileDetect(navigator.userAgent);
};

export default useMobileDetect;
